import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'ui/components';
import cn from 'classnames';

const initialState = {
  no_vessel: '',
  bl_code: '',
  no_container: '',
};

export const FormSea = ({ onValueChange, initialValue, removePadding }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ no_vessel, bl_code, no_container }, setState] =
    React.useState(initialState);

  React.useEffect(() => {
    const value = {
      no_vessel,
      bl_code,
      no_container,
    };
    onValueChange(value);
  }, [no_vessel, bl_code, no_container]);

  React.useEffect(() => {
    if (!initialValue) return;

    setState((prevState) => ({
      ...prevState,
      no_vessel: initialValue?.no_vessel,
      bl_code: initialValue?.bl_code,
      no_container: initialValue?.no_container,
    }));
  }, [initialValue]);

  return (
    <div className={cn(removePadding ? 'p-0' : 'p-3', 'h-100')}>
      <div className="row">
        <div className="col-md-6">
          <Form.Input
            required
            value={bl_code}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                bl_code: e.target.value,
              }))
            }
            type="text"
            label="BL Code "
            error={StateForm?.errors['sea_freight.bl_code']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            value={no_container}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                no_container: e.target.value,
              }))
            }
            type="text"
            label="No. Container "
            error={StateForm?.errors['sea_freight.no_container']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            value={no_vessel}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                no_vessel: e.target.value,
              }))
            }
            type="text"
            label="No. Vessel "
            error={StateForm?.errors['sea_freight.no_vessel']}
          />
        </div>
      </div>
    </div>
  );
};
